import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TemplateComponent } from '@app/_v2/template/template.component';
import { PageNotFoundComponent } from '@app/shared/components/page-not-found.component';
import { CountryRestrictionGuard } from '@app/country-restriction/country-restriction.guard';
import { AuthenticationGuard, extract } from '@app/core';

const routes: Routes = [
  {
    path: '',
    component: TemplateComponent,
    canActivate: [CountryRestrictionGuard],
    children: [
      {
        path: 'home',
        loadChildren: 'app/_v2/home/home.module#HomeModule',
        data: { allowChat: true, hero: true, subHeader: true, title: extract('Edgeless Casino') },
      },
      {
        path: 'games',
        loadChildren: 'app/_v2/games/games.module#GamesModule',
        data: { allowChat: true, subHeader: true, title: extract('Edgeless - Games') },
      },
      {
        path: 'jackpot',
        loadChildren: 'app/_v2/jackpot/jackpot.module#JackpotModule',
        data: { allowChat: true, subHeader: true, title: extract('Edgeless - Jackpot') },
      },
      {
        path: 'account',
        loadChildren: 'app/_v2/account/account.module#AccountModule',
        data: { allowChat: false, subHeader: true, title: extract('Edgeless - Account') },
        canActivate: [AuthenticationGuard],
        canLoad: [AuthenticationGuard],
      },
      {
        path: 'legal',
        loadChildren: 'app/_v2/legal/legal.module#LegalModule',
        data: { allowChat: false, subHeader: true, title: extract('Edgeless - Legal') },
      },
    ],
  },
  {
    path: '404',
    component: PageNotFoundComponent,
  },
  {
    path: '**',
    redirectTo: '/404',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class TemplateRoutingModule {}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/template-routing.module.ts